import { render, staticRenderFns } from "./space-image.vue?vue&type=template&id=0b6e370f&scoped=true&"
import script from "./space-image.vue?vue&type=script&lang=js&"
export * from "./space-image.vue?vue&type=script&lang=js&"
import style0 from "./space-image.vue?vue&type=style&index=0&id=0b6e370f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e370f",
  null
  
)

export default component.exports